import ManageMealTemplate from './ManageMealTemplate';

export default ManageMealTemplate;
